module.exports = __webpack_public_path__ + "static/media/ex2.81941560.jpg";